import { transformDateValue } from 'core/js/FormUtils';
export const getPackagingsizeView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let packagingsizeList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Form Name","fieldValue":transformDataValue(data.formname,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          packagingsizeList.push(card);
  })
  return packagingsizeList;
}